 
 
 
 
 

const index = ({id="",addClass="",style={},text}) => {
    return (
        
                <p
                id={id}
                className={"BODY_LARGE " +addClass} 
                style={style}
                >{text}</p>
                
         
    );
  }
  
  export default index;
  